// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"01c74fc8","239":"9180e550","453":"258b012d","732":"2b0c75ff"}[chunkId] + ".chunk.js";
};